module.exports = __webpack_public_path__ + "img/image143.42becd21.png";